import { c as _c } from "react/compiler-runtime";
import type { ListGiftOrderHistoryDto } from '__generated__/api/auth';
import { Button } from '@common/components';
import { useToast } from '@common/hooks';
import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Link from 'next/link';
import { AuthMutation } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { normalizeOrderStatus, ORDER_STATUS, ORDER_STATUS_ACTIONS } from '@/app/donation/constants';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useCustomRouter } from '@/hooks/useCustomRouter';
interface OrderCardProps {
  order: ListGiftOrderHistoryDto;
  onProductClick?: () => void;
  className?: string;
}
export const OrderCard = t0 => {
  const $ = _c(57);
  const {
    order,
    onProductClick,
    className
  } = t0;
  const {
    push
  } = useCustomRouter();
  const {
    toast,
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== order.orderStatusCd) {
    t1 = normalizeOrderStatus(order.orderStatusCd);
    $[0] = order.orderStatusCd;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const normalizedStatus = t1;
  const allActions = ORDER_STATUS_ACTIONS[normalizedStatus] || [];
  const actions = allActions.filter(_temp);
  const canWriteReview = allActions.some(_temp2);
  const canTrackDelivery = normalizedStatus === ORDER_STATUS.IN_DELIVERY;
  const showDeliveryPreparing = normalizedStatus === ORDER_STATUS.DELIVERY_PREPARING;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = AuthMutation["put:/wello/v2/auth/home/gift/order/{orderId}/status"]();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== queryClient || $[4] !== toast) {
    t3 = async () => {
      await queryClient.invalidateQueries();
      toast({
        message: "\uC8FC\uBB38\uC0C1\uD0DC\uAC00 \uBCC0\uACBD\uB418\uC5C8\uC5B4\uC694"
      });
    };
    $[3] = queryClient;
    $[4] = toast;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== toastError) {
    t4 = error => {
      toastError({
        error
      });
    };
    $[6] = toastError;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = {
      ...t2,
      onSuccess: t3,
      onError: t4
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const updateOrderStatusMutation = useMutation(t5);
  let t6;
  if ($[11] !== order.giftOrderId || $[12] !== push || $[13] !== updateOrderStatusMutation) {
    t6 = action => {
      bb12: switch (action) {
        case "confirm":
          {
            updateOrderStatusMutation.mutate({
              path: {
                orderId: order.giftOrderId
              },
              body: {
                status: "PURCHASE_CONFIRMED",
                reason: "\uAD6C\uB9E4\uD655\uC815"
              }
            });
            break bb12;
          }
        case "delivery":
          {
            push(`${DONATION_ROUTES.DONATION_MY_ORDERS_DETAIL.withSearchParams({
              dynamicPath: {
                id: order.giftOrderId
              }
            })}#delivery-info`);
          }
      }
    };
    $[11] = order.giftOrderId;
    $[12] = push;
    $[13] = updateOrderStatusMutation;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleActionClick = t6;
  let t7;
  if ($[15] !== className) {
    t7 = cn("flex flex-col gap-16", className);
    $[15] = className;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("flex flex-col gap-16", "mobile-tablet:gap-12");
    t9 = cn("flex h-48 items-center justify-between border-b border-Gray-300 px-16", "mobile-tablet:px-0");
    $[17] = t8;
    $[18] = t9;
  } else {
    t8 = $[17];
    t9 = $[18];
  }
  const t10 = order.orderedAt ?? "-";
  let t11;
  if ($[19] !== t10) {
    t11 = <time className="font-500 text-Gray-700 typo-body4">{t10}</time>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== order.giftOrderId) {
    t12 = DONATION_ROUTES.DONATION_MY_ORDERS_DETAIL.withSearchParams({
      dynamicPath: {
        id: order.giftOrderId
      }
    });
    $[21] = order.giftOrderId;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SvgChevronright className="size-16" />;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12) {
    t14 = <Link href={t12} className="flex items-center gap-4 font-700 text-Gray-600 typo-body4">주문상세{t13}</Link>;
    $[24] = t12;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t11 || $[27] !== t14) {
    t15 = <div className={t9}>{t11}{t14}</div>;
    $[26] = t11;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = cn("px-16 font-700 text-Gray-black typo-body2", "mobile-tablet:px-0 mobile-tablet:typo-body3");
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== order.orderStatusValue) {
    t17 = <p className={t16}>{order.orderStatusValue}</p>;
    $[30] = order.orderStatusValue;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t15 || $[33] !== t17) {
    t18 = <header className={t8}>{t15}{t17}</header>;
    $[32] = t15;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = cn("flex justify-between gap-20 px-16", "mobile-tablet:flex-col mobile-tablet:px-0");
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  let t21;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = cn("flex items-center gap-4", "mobile-tablet:gap-2");
    t21 = cn("relative size-24 shrink-0 overflow-hidden rounded-pill border border-Gray-300", "mobile-tablet:size-20");
    $[36] = t20;
    $[37] = t21;
  } else {
    t20 = $[36];
    t21 = $[37];
  }
  let t22;
  if ($[38] !== order.homeInstitutionLogoUrl || $[39] !== order.homeInstitutionName) {
    t22 = <div className={t21}><Image src={order.homeInstitutionLogoUrl} alt={order.homeInstitutionName} fill={true} sizes={`${BREAKPOINTS.MOBILE_TABLET} 20px, 24px`} className="object-cover" /></div>;
    $[38] = order.homeInstitutionLogoUrl;
    $[39] = order.homeInstitutionName;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = cn("font-600 text-Gray-600 typo-caption1", "mobile-tablet:typo-body4");
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== order.homeInstitutionName) {
    t24 = <span className={t23}>{order.homeInstitutionName}</span>;
    $[42] = order.homeInstitutionName;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== t22 || $[45] !== t24) {
    t25 = <div className={t20}>{t22}{t24}</div>;
    $[44] = t22;
    $[45] = t24;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  const t26 = order.products?.map(product => <div key={product.giftOrderProductId} className="flex items-start justify-between gap-12"><div className="flex flex-1 gap-12"><Image src={product.productMainImageUrl ?? ""} alt={product.productName ?? ""} width={72} height={72} className="size-104 shrink-0 rounded-small border border-Gray-100 object-cover mobile-tablet:size-72" /><div className="flex flex-1 flex-col"><h3 className={cn("line-clamp-2 pb-4 font-500 text-Gray-black typo-body3", "mobile-tablet:typo-body4")}><CustomLink href={DONATION_ROUTES.GIFTS_DETAIL.pathname({
            productNumber: product.productNumber ?? ""
          })} onClick={onProductClick}>{product.productName}</CustomLink></h3>{product.optionItemList?.length ? <p className={cn("font-400 text-Gray-600 typo-body4", "mobile-tablet:typo-caption1")}>옵션: {product.optionItemList.join(", ")}</p> : null}{canTrackDelivery || showDeliveryPreparing ? <p className={cn("font-400 text-Gray-600 typo-body4", "mobile-tablet:typo-caption1")}>배송: 2~7일 예상 (식품의 경우 지연 시 1~2주 소요)</p> : null}<p className={cn("font-400 text-Gray-600 typo-body4", "mobile-tablet:typo-caption1")}>수량: {product.quantity}개</p></div></div>{canWriteReview && <Button type="button" dimensions="H32" theme="sub-line" className="shrink-0" onClick={() => {
      if (product.reviewId) {
        push(DONATION_ROUTES.MY_REVIEW_EDIT.withSearchParams({
          dynamicPath: {
            reviewId: product.reviewId
          },
          searchParams: {
            redirect: DONATION_ROUTES.DONATION_MY_ORDERS.pathname
          }
        }));
      } else {
        push(DONATION_ROUTES.MY_REVIEW_CREATE.withSearchParams({
          dynamicPath: {
            orderId: order.giftOrderId
          },
          searchParams: {
            redirect: DONATION_ROUTES.DONATION_MY_ORDERS.pathname,
            giftOrderProductId: String(product.giftOrderProductId)
          }
        }));
      }
    }}>{product.reviewId ? "\uD6C4\uAE30\uC218\uC815" : "\uD6C4\uAE30\uC791\uC131"}</Button>}</div>);
  let t27;
  if ($[47] !== t26) {
    t27 = <div className="flex flex-col gap-12">{t26}</div>;
    $[47] = t26;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== t25 || $[50] !== t27) {
    t28 = <section className={t19}><div className="flex flex-1 flex-col gap-12">{t25}{t27}</div></section>;
    $[49] = t25;
    $[50] = t27;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  const t29 = actions.length > 0 ? <div className="flex justify-end"><footer className={cn("grid w-284 shrink-0 grid-cols-2 items-start gap-8", "mobile-tablet:w-full", {
      "grid-cols-1": actions.length < 2
    })}>{actions.map((action_0, index) => <Button key={index} type="button" className="flex-1" dimensions="H40" theme="sub-line" onClick={() => handleActionClick(action_0.action)}>{action_0.label}</Button>)}</footer></div> : null;
  let t30;
  if ($[52] !== t18 || $[53] !== t28 || $[54] !== t29 || $[55] !== t7) {
    t30 = <><article className={t7}>{t18}{t28}{t29}</article></>;
    $[52] = t18;
    $[53] = t28;
    $[54] = t29;
    $[55] = t7;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  return t30;
};
function _temp(a) {
  return a.action !== "review";
}
function _temp2(a_0) {
  return a_0.action === "review";
}